import { useTranslation } from 'react-i18next';

const COUNTRIES = [
  { code: 'fr', nameKey: 'world.c_fr' }, { code: 'be', nameKey: 'world.c_be' }, { code: 'es', nameKey: 'world.c_es' },
  { code: 'gb', nameKey: 'world.c_gb' }, { code: 'it', nameKey: 'world.c_it' }, { code: 'ca', nameKey: 'world.c_ca' },
  { code: 'us', nameKey: 'world.c_us' }, { code: 'de', nameKey: 'world.c_de' }, { code: 'ch', nameKey: 'world.c_ch' },
  { code: 'pt', nameKey: 'world.c_pt' }, { code: 'nl', nameKey: 'world.c_nl' }, { code: 'tn', nameKey: 'world.c_tn' },
  { code: 'ci', nameKey: 'world.c_ci' }, { code: 'cm', nameKey: 'world.c_cm' }, { code: 'sa', nameKey: 'world.c_sa' },
];

export default function WorldCoverage() {
  const { t } = useTranslation();
  return (
    <section className="py-12 sm:py-16 md:py-24 bg-gradient-to-b from-background via-card/30 to-background relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
            <span className="text-sm font-medium text-primary">{t('world.badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">
            <span className="text-gradient">{t('world.title1')}</span><br />
            <span className="text-foreground">{t('world.title2')}</span>
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed px-2">{t('world.desc')}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
          {COUNTRIES.map(({ code, nameKey }) => (
            <div key={code} className="flex flex-col items-center p-4 rounded-2xl bg-card/50 border border-border/50 backdrop-blur-sm hover:border-primary/50 hover:bg-card/80 transition-all duration-300 group hover:scale-105 cursor-default">
              <img src={`https://flagcdn.com/w80/${code}.png`} alt={t(nameKey)} className="w-16 h-12 object-cover rounded mb-2 group-hover:scale-110 transition-transform" loading="lazy" />
              <span className="text-sm font-medium text-foreground">{t(nameKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
